import React from "react";

const Amortissements = () => {
  return (
    <div className="amortissements">
      <h2>Amortissements</h2>
      <p>Calcul et suivi des amortissements des actifs.</p>
    </div>
  );
};

export default Amortissements;
